import {
  CHANGE_ADMIN_MENU,
  LOCATION_CHANGE,
  SEARCH_ADMIN_INVOICE_SUCCESS,
  SEARCH_ADMIN_INVOICE_FAILED,
  EXPAND_ADMIN_INVOICE_TRUE,
  EXPAND_ADMIN_INVOICE_FALSE,
  EXPAND_ADMIN_USER_TRUE,
  EXPAND_ADMIN_USER_FALSE,
  SEARCH_ADMIN_USERS_SUCCESS,
  SEARCH_ADMIN_USERS_FAILED,
  //UPDATE_ADMIN_INVOICE,
  //UPDATE_ADMIN_INVOICE_RESULT,
  HIDE_ADMIN_SNACKBAR,
  //UPDATE_ADMIN_USER,
  UPDATE_ADMIN_USER_RESULT,
  UPDATE_ADMIN_USER_RESULT_FAILED,
  SEARCH_ADMIN_WAGES_SUCCESS,
  SEARCH_ADMIN_WAGES_IR_FALIED,
  SEARCH_ADMIN_WAGES_IR_SUCCESS,
  SEARCH_ADMIN_WAGES_FAILED,
  IR_SEARCH_PAGE_CHANGE,
  USER_SEARCH_PAGE_CHANGE,
  TIEDOTTEET_SEARCH_PAGE_CHANGE,
  WARN_INVOICE_TO_PAY,
  WARN_SALARY_TO_PAY,
  CONFIRM_SALARY_TO_PAY,
  UPDATE_ADMIN_INVOICE_STATUS,
  CANCEL_UPDATE_ADMIN_INVOICE_STATUS,
  CLOSE_DIALOG,
  UPDATE_ADMIN_SALARY_STATUS,
  SALARY_SEND_TO_IR,
  CANCEL_SALARY_IR_REPORT,
  CANCEL_UPDATE_ADMIN_SALARY_STATUS,
  REMOVE_PAYMENT_DIALOG,
  UPDATE_ADMIN_INVOICE_STATUS_SUCCESS,
  UPDATE_ADMIN_SALARY_STATUS_SUCCESS,
  UPDATE_ADMIN_SALARY_STATUS_FAILED,
  ADMIN_GET_UPDATES_SUCCESS,
  NO_PIKAPALKKA,
  UPDATE_ADMIN_INVOICE_STATUS_REJECTED,
  UPDATE_ADMIN_INVOICE_STATUS_NEW,
  UPDATE_ADMIN_INVOICE_STATUS_LOANED,
  UPDATE_ADMIN_INVOICE_STATUS_NOT_ACCEPTED,
  UPDATE_ADMIN_INVOICE_STATUS_PAID_AND_NEW_INVOICE,
  UPDATE_ADMIN_BANK_PAYMENT_SUCCESS,
  UPDATE_ADMIN_BANK_PAYMENT_FAILED,
  UPDATE_ADMIN_IR_FAILED,
  GET_ADMIN_EXPENSE_REPORT_SUCCESS,
  GET_ADMIN_EXPENSE_REPORT_FAILED,
  ADMIN_SALARY_PAGE_SIZE,
  ADMIN_INVOICE_PAGE_SIZE,
  CLOSE_ADMIN_USER_FORMS,
  CLOSE_ADMIN_USER_FORMS_SUCCESS,
  UPDATE_ADMIN_TABLE,
  UPDATE_ADMIN_TABLE_SUCCESS,
  CANCEL_UPDATE_ADMIN_SALARY_STATUS_SUCCESS,
  GET_FIELD_OF_WORK_SUCCESS,
  SEARCH_ADMIN_INVOICE_ALL_ROWS_SUCCESS,
  CLOSE_ADMIN_INVOICE_FORMS,
  CLOSE_ADMIN_INVOICE_FORMS_SUCCESS,
  ADMIN_GENERATE_PDF_FAILED,
  ADMIN_UPDATE_INDUSTRY_TAX_CARD_SUCCESS,
  ADMIN_UPDATE_INDUSTRY_TAX_CARD_FAILED,
  SEARCH_ADMIN_SALARY_ALL_RECORDS_SUCCESS,
  SSN_DUPLICATE,
  EXPAND_ADMIN_SALARY_TRUE,
  EXPAND_ADMIN_SALARY_FALSE,
  CLOSE_ADMIN_SALARY_FORMS,
  CLOSE_ADMIN_SALARY_FORMS_SUCCESS,
  REMOVE_INVOICE_FEE_WITH_REASON,
  CANCEL_REMOVE_INVOICE_FEE_DIALOG,
  SEARCH_ADMIN_USERS,
  SEARCH_ADMIN_IR,
  GET_ADMIN_SALARY_ULOSOTTO_INFO_SUCCESS
} from '../constants'
{
  /* Redo the EXPAND_ADMIN_INVOICE_TRUE, no need DateTimeFormat any more 
 import DateTimeFormat from '../utils/DateTimeFormat' */
}
import { convertIntToState, isValidGroup } from '../utils/invoice.utils'
import { concatReverseReduceSortFunction } from '../utils/dashboard.utils'

const initialState = {
  selectedMenuItem: 0,
  //showSpinner: false,
  showAdminSnackbar: false,
  showAdminFailSnackbar: false,
  showAdminSalPayFailSnackbar: false,
  showAdminSalaryStatusSuccessSnackbar: false,
  invoiceSearchRows: [],
  currentMonthSumUlosotto: 0,
  maxMonthlyGovPay: 0,
  searchInvoiceSummary: {
    ID: 0,
    sum_quick_pay_with_tax: 0,
    sum_quick_pay_without_tax: 0,
    total_quick_pay_vat: 0,
    sum_vakuutus_with_tax: 0,
    sum_vakuutus_without_tax: 0,
    total_vakuutus_vat: 0,
    sum_with_tax: 0,
    sum_without_tax: 0,
    sum_with_14_tax: 0,
    sum_without_14_tax: 0,
    sum_with_0_tax: 0,
    sum_without_0_tax: 0,
    sum_with_25_5_tax: 0,
    sum_without_25_5_tax: 0,
    sum_with_24_tax: 0,
    sum_without_24_tax: 0,
    sum_with_10_tax: 0,
    sum_without_10_tax: 0,
    sum_25_5_vat: 0,
    sum_24_vat: 0,
    sum_14_vat: 0,
    sum_10_vat: 0,
    total_vat: 0,
    sum_building_construction_0_tax: 0
  },
  userSearchRows: [],
  salarySearchRows: [],
  salarySearchSummary: {
    total_gross_salary: 0,
    total_tax_cost: 0,
    total_mileage_allowance: 0,
    total_daily_allowance: 0,
    total_service_cost: 0,
    total_social_contribution: 0,
    total_take_home_pay: 0,
    total_ulosotto_sum: 0,
    total_reimbursment_cost: 0,
    total_yel_cost: 0,
    expenses: {
      total_vat_amount: 0,
      sum_incl_vat_25_5: 0,
      sum_incl_vat_24: 0,
      sum_incl_vat_14: 0,
      sum_incl_vat_10: 0,
      sum_incl_vat_0: 0
    }
  },
  irSearchRows: [],
  releaseSearchRows: [],
  selected: 0,
  totalInvoiceCount: 0,
  totalSalariesCount: 0,
  isToPayInvoiceId: 0,
  isToPay: false,
  isInvoiceUnclear: false,
  isPerinnassa: false,
  isReklamoitu: false,
  isLahetetty: false,
  invoicepaid: 0,
  selectedRows: [],
  isSalaryRowSelected: false,
  isToLiftSalary: false,
  isImportSalary: false,
  isValidBatch: true,
  isIRValidBatch: true,
  isIRCacelReportValidBatch: true,
  isToPaySalaryId: 0,
  Status: '',
  instant_payment: '',
  salPayFailMessage: '',
  salaryStatusSuccessMessage: '',
  showExpenseReportSuccessSnackbar: false,
  //expenseReportSuccessMessage: '',
  showExpenseReportFailedSnackbar: false,
  expenseReportFailedMessage: '',
  // Initial default page sizes from constants.
  adminInvoicePageSize: ADMIN_INVOICE_PAGE_SIZE,
  adminSalaryPageSize: ADMIN_SALARY_PAGE_SIZE,
  shouldCloseUserForms: false,
  shouldCloseInvoiceForms: false,
  shouldUpdateTable: false,
  fieldOfWork: [],
  adminInvoiceEdit: [],
  dueInvoiceIds: [],
  isMuokattu: false,
  isAdminSent: false,
  allInvoiceInMonthSearch: [],
  industryTaxCard: [],
  isUpdateTaxCardSuccess: false,
  isUpdateTaxCardFailed: false,
  isAdminRejected: false,
  showPartialPayFailSnackbar: false,
  partialPayFailMessage: '',
  allSalaryRecords: [],
  isAdminHalfPaid: false,
  allSalaryRecords: [],
  showSsnSnackbar: false,
  adminSalaryEdit: [],
  shouldCloseSalaryForms: false,
  isReminderActive: false,
  showRemoveInvoiceFeeDialog: false,
  feeType: '',
  invoiceNotes: '',
  is_group_invoice: false
}

const adminReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_FIELD_OF_WORK_SUCCESS:
      return {
        ...state,
        fieldOfWork: [...action.data]
      }

    case CHANGE_ADMIN_MENU:
      return Object.assign(
        {},
        { ...state },
        { selectedMenuItem: action.value },
        {
          invoiceSearchRows: [],
          allInvoiceInMonthSearch: [],
          userSearchRows: [],
          industryTaxCard: [],
          salarySearchRows: [],
          currentMonthSumUlosotto: 0,
          maxMonthlyGovPay: 0,
          irSearchRows: [],
          selected: 0,
          totalInvoiceCount: 0,
          totalSalariesCount: 0,
          searchInvoiceSummary: {
            ID: 0,
            sum_quick_pay_with_tax: 0,
            sum_quick_pay_without_tax: 0,
            total_quick_pay_vat: 0,
            sum_vakuutus_with_tax: 0,
            sum_vakuutus_without_tax: 0,
            total_vakuutus_vat: 0,
            sum_with_tax: 0,
            sum_without_tax: 0,
            sum_with_14_tax: 0,
            sum_without_14_tax: 0,
            sum_with_0_tax: 0,
            sum_without_0_tax: 0,
            sum_with_25_5_tax: 0,
            sum_without_25_5_tax: 0,
            sum_with_24_tax: 0,
            sum_without_24_tax: 0,
            sum_with_10_tax: 0,
            sum_without_10_tax: 0,
            sum_25_5_vat: 0,
            sum_24_vat: 0,
            sum_14_vat: 0,
            sum_10_vat: 0,
            total_vat: 0,
            sum_building_construction_0_tax: 0
          },
          salarySearchSummary: {
            total_gross_salary: 0,
            total_tax_cost: 0,
            total_mileage_allowance: 0,
            total_daily_allowance: 0,
            total_service_cost: 0,
            total_social_contribution: 0,
            total_take_home_pay: 0,
            total_ulosotto_sum: 0,
            total_reimbursment_cost: 0,
            total_yel_cost: 0,
            expenses: {
              total_vat_amount: 0,
              sum_incl_vat_25_5: 0,
              sum_incl_vat_24: 0,
              sum_incl_vat_14: 0,
              sum_incl_vat_10: 0,
              sum_incl_vat_0: 0
            }
          },
          isToLiftSalary: false,
          // Initialize page sizes from constants (when tabs are changed)
          adminInvoicePageSize: ADMIN_INVOICE_PAGE_SIZE,
          adminSalaryPageSize: ADMIN_SALARY_PAGE_SIZE
        }
      )

    case LOCATION_CHANGE:
      return Object.assign(
        {},
        { ...state },
        {
          invoiceSearchRows: [],
          allInvoiceInMonthSearch: [],
          userSearchRows: [],
          industryTaxCard: [],
          salarySearchRows: [],
          currentMonthSumUlosotto: 0,
          maxMonthlyGovPay: 0,
          irSearchRows: [],
          selectedRows: [],
          isSalaryRowSelected: false,
          selected: 0,
          totalInvoiceCount: 0,
          totalSalariesCount: 0,
          searchInvoiceSummary: {
            ID: 0,
            sum_quick_pay_with_tax: 0,
            sum_quick_pay_without_tax: 0,
            total_quick_pay_vat: 0,
            sum_vakuutus_with_tax: 0,
            sum_vakuutus_without_tax: 0,
            total_vakuutus_vat: 0,
            sum_with_tax: 0,
            sum_without_tax: 0,
            sum_with_14_tax: 0,
            sum_without_14_tax: 0,
            sum_with_0_tax: 0,
            sum_without_0_tax: 0,
            sum_with_25_5_tax: 0,
            sum_without_25_5_tax: 0,
            sum_with_24_tax: 0,
            sum_without_24_tax: 0,
            sum_with_10_tax: 0,
            sum_without_10_tax: 0,
            sum_25_5_vat: 0,
            sum_24_vat: 0,
            sum_14_vat: 0,
            sum_10_vat: 0,
            total_vat: 0,
            sum_building_construction_0_tax: 0
          },
          salarySearchSummary: {
            total_gross_salary: 0,
            total_tax_cost: 0,
            total_mileage_allowance: 0,
            total_daily_allowance: 0,
            total_service_cost: 0,
            total_social_contribution: 0,
            total_take_home_pay: 0,
            total_ulosotto_sum: 0,
            total_reimbursment_cost: 0,
            total_yel_cost: 0,
            expenses: {
              total_vat_amount: 0,
              sum_incl_vat_25_5: 0,
              sum_incl_vat_24: 0,
              sum_incl_vat_14: 0,
              sum_incl_vat_10: 0,
              sum_incl_vat_0: 0
            }
          },
          adminInvoicePageSize: ADMIN_INVOICE_PAGE_SIZE,
          adminSalaryPageSize: ADMIN_SALARY_PAGE_SIZE,
          showAdminSnackbar: false,
          isPerinnassa: false,
          isLahetetty: false,
          isReklamoitu: false,
          isUpdateTaxCardSuccess: false,
          isUpdateTaxCardFailed: false,
          isMuokattu: false,
          isAdminSent: false,
          isAdminRejected: false,
          showPartialPayFailSnackbar: false,
          partialPayFailMessage: '',
          isAdminHalfPaid: false,
          showSsnSnackbar: false,
          is_group_invoice: false
        },
        { selectedMenuItem: 0 }
      )

    case SEARCH_ADMIN_INVOICE_SUCCESS:
      var refreshSearch = action.refreshSearch
      // invoiceRows is either old set of searched results (page change) or an empty array (if the user presses search button)
      var invoiceRows = refreshSearch ? [] : state.invoiceSearchRows
      // Update the invoice summary only if search is refreshed. Or else, pick up previous state of summary (on page change).
      var invoiceSummary = refreshSearch
        ? action.searchInvoiceSummaryResult
        : state.searchInvoiceSummary
      // Set to 0 if search is pressed (handled in saga.)
      var selected = action.selectedPage

      // For every invoice in the response data, do one of the following.
      //  - Update existing record with updated data or
      //  - Append to list of invoices in state

      action.invoices.map((newInvoice) => {
        // Find ID of invoice in invoiceRows array (invoice id and uuid should match)
        let invoiceIdx = invoiceRows.findIndex(
          (inv) =>
            inv.invoice_id == newInvoice.invoice_id &&
            inv.partial_invoice_id == newInvoice.partial_invoice_id &&
            inv.uuid == newInvoice.uuid
        )
        // New invoice => append to end of existing invoice list
        if (invoiceIdx == -1)
          invoiceRows.push({ ...newInvoice, expanded: false })
        // Else, update existing record of invoice in the invoiceRows state array
        else {
          // Maintain expanded property and update rest
          invoiceRows[invoiceIdx] = {
            ...newInvoice,
            expanded: invoiceRows[invoiceIdx].expanded
          }
        }
      })
      return Object.assign(
        {},
        { ...state },
        {
          invoiceSearchRows: invoiceRows,
          searchInvoiceSummary: invoiceSummary,
          selected: selected,
          totalInvoiceCount: action.totalInvoiceCount,
          adminInvoicePageSize: action.adminInvoicePageSize,
          allInvoiceInMonthSearch: []
        }
      )

    // KAS-337 When searching invoices in month it will fetch all invoices as TotalCount, not return only selected page
    case SEARCH_ADMIN_INVOICE_ALL_ROWS_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          allInvoiceInMonthSearch: action.invoices
        }
      )

    // PI-296 Fetching all admin salary records
    case SEARCH_ADMIN_SALARY_ALL_RECORDS_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          allSalaryRecords: action.salaries
        }
      )

    case SEARCH_ADMIN_INVOICE_FAILED:
      return Object.assign({}, { ...state }, {})

    case SEARCH_ADMIN_USERS:
      return Object.assign(
        {},
        {
          ...state
        },
        {
          selected: 0
        }
      )

    case SEARCH_ADMIN_IR:
      return Object.assign(
        {},
        {
          ...state
        },
        {
          selected: 0
        }
      )

    case SEARCH_ADMIN_USERS_SUCCESS:
      const newUserRows = []
      for (let row of action.result) {
        newUserRows.push({ ...row, expanded: false })
      }
      return Object.assign(
        {},
        { ...state },
        {
          userSearchRows: newUserRows
        }
      )

    case SEARCH_ADMIN_USERS_FAILED:
      return Object.assign({}, { ...state }, {})

    case CLOSE_ADMIN_USER_FORMS:
      return Object.assign(
        {},
        { ...state },
        {
          shouldCloseUserForms: true
        }
      )

    case CLOSE_ADMIN_USER_FORMS_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          shouldCloseUserForms: false
        }
      )

    case CLOSE_ADMIN_INVOICE_FORMS:
      return Object.assign(
        {},
        { ...state },
        {
          shouldCloseInvoiceForms: true
        }
      )

    case CLOSE_ADMIN_INVOICE_FORMS_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          shouldCloseInvoiceForms: false
        }
      )

    case SEARCH_ADMIN_WAGES_SUCCESS:
      // salaryRows is either old set of searched results (page change) or an empty array (if the user presses search button)
      var refreshSearch = action.refreshSearch
      let salaryRows = refreshSearch ? [] : state.salarySearchRows
      // Update the salary summary only if search is refreshed. Or else, pick up previous state of summary (on page change).
      var salarySearchSummary = refreshSearch
        ? action.salarySearchSummary
        : state.salarySearchSummary
      var selected = action.selectedPage
      var isSalaryRowSelected = false

      // For every salary in the http response do one of the following,
      //    - update existing salary entry if previously searched
      //    - or append to salaryRows
      action.result.map((result) => {
        // index of existing searched salary
        let salIdx = salaryRows.findIndex(
          (sal) => sal.id == result.id && sal.uuid == result.uuid
        )
        // new salary in response.
        if (salIdx == -1) {
          salaryRows.push({
            ...result,
            expanded: false,
            isChecked: false
          })
        }
        // update old salary with new one.
        // Maintain old checked and expanded props (if valid).
        else {
          // Check if checkbox can be selected. (same checks as in admin.component)
          let canSelect =
            result.status === 'BankingInitiation' ||
            result.dedtstatus === 'BankingInitiation' ||
            (result.status === 'bankingprocess' &&
              result.dedtstatus === 'bankingprocess') ||
            (result.status === 'bankingprocess' &&
              result.dedtstatus === 'paid') ||
            (result.status === 'bankingprocess' &&
              result.dedtstatus === 'Pplasku') ||
            result.status === 'IRManual'
              ? false
              : true
          // If the row cannot be selected, set isChecked to false.
          // If the row can be selected, previous checked status is maintained
          let isChecked = salaryRows[salIdx].isChecked && canSelect
          // Re-evaluate if at least one salary row is selected
          isSalaryRowSelected = isSalaryRowSelected || isChecked
          salaryRows[salIdx] = {
            ...result,
            expanded: salaryRows[salIdx].expanded,
            isChecked: isChecked
          }
        }
      })

      // Sort by created date descending order
      salaryRows.sort((a, b) => Date.parse(b.created) - Date.parse(a.created))

      return Object.assign(
        {},
        { ...state },
        { salarySearchRows: salaryRows },
        { salarySearchSummary: salarySearchSummary },
        // Huy added for selection reset
        { isSalaryRowSelected: isSalaryRowSelected },
        { isIRCacelReportValidBatch: true },
        { isValidBatch: true },
        { Status: '' },
        { isIRValidBatch: true },
        // Select rows which are checked
        { selectedRows: salaryRows.filter((sal) => sal.isChecked) },
        { selected: selected },
        { totalSalariesCount: action.totalSalariesCount },
        { adminSalaryPageSize: action.adminSalaryPageSize }
      )

    case SEARCH_ADMIN_WAGES_FAILED:
      return Object.assign({}, { ...state }, {})

    case SEARCH_ADMIN_WAGES_IR_SUCCESS:
      const irSalaryRows = []

      //For Batch Payment Selection
      for (let row of action.result) {
        irSalaryRows.push({ ...row, expanded: false })
      }

      return Object.assign({}, { ...state }, { irSearchRows: irSalaryRows })

    case SEARCH_ADMIN_WAGES_IR_FALIED:
      return Object.assign({}, { ...state }, {})

    // case UPDATE_ADMIN_IR_FAILED:
    //   return Object.assign(
    //     {},
    //     { ...state },
    //     {
    //       selectedRows: [],
    //       isSalaryRowSelected: false,
    //       isToLiftSalary: false,
    //       showAdminSalaryStatusSuccessSnackbar: true,
    //       salaryStatusSuccessMessage: action.result
    //     }
    //   )

    case GET_ADMIN_EXPENSE_REPORT_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          showExpenseReportSuccessSnackbar: true
          //expenseReportSuccessMessage: action.result.data.message
        }
      )

    case GET_ADMIN_EXPENSE_REPORT_FAILED:
      return Object.assign(
        {},
        { ...state },
        {
          showExpenseReportFailedSnackbar: true,
          expenseReportFailedMessage: action.result
        }
      )

    case EXPAND_ADMIN_INVOICE_TRUE:
      let result = action.result.Invoice[0]
      const updateRows = []
      for (let row of state.invoiceSearchRows) {
        if (row.invoice_id == result.invoice_id) {
          result.state = convertIntToState(result.state)
          updateRows.push({
            ...row,
            expanded: true,
            expandData: result
          })
        } else updateRows.push({ ...row })
      }
      return Object.assign(
        {},
        { ...state },
        {
          invoiceSearchRows: updateRows,
          adminInvoiceEdit: action.result,
          dueInvoiceIds: action.dueInvoiceIds
        }
      )

    case EXPAND_ADMIN_INVOICE_FALSE:
      const closeUpdateRows = []
      for (let row of state.invoiceSearchRows) {
        row.invoice_id == action.result.Invoice[0].invoice_id
          ? closeUpdateRows.push({ ...row, expanded: false, expandData: null })
          : closeUpdateRows.push({ ...row })
      }
      return Object.assign(
        {},
        { ...state },
        { invoiceSearchRows: closeUpdateRows }
      )

    case EXPAND_ADMIN_USER_TRUE:
      let userResult = { ...action.result }
      let industryTaxResult = action.industryTaxInfo
      if (userResult.yelSelect == 'yel_self') {
        userResult.yelSelect = 'Maksan YEL-vakuutuksen itse'
      } else if (userResult.yelSelect == 'yel_recommended') {
        userResult.yelSelect = 'Maksetaan YEL-vakuutus tulojen mukaan 24,10 %'
      } else if (userResult.yelSelect == 'yel_minimum') {
        userResult.yelSelect = 'Maksan minimi YEL-vakuutuksen (9010,28 €)'
      } else {
        userResult.yelSelect = 'En ole YEL-vakuutusvelvollinen'
      }

      // Huong - kas344 industry tax card
      if (industryTaxResult?.path) {
        userResult.taxCard_number = industryTaxResult.tax_number
        userResult.taxCard_unit = industryTaxResult.apartment_number
        userResult.taxCard_zip_code = industryTaxResult.postal_code
        userResult.taxCard_address = industryTaxResult.card_delivery_address
        userResult.taxCard_city = industryTaxResult.city
        userResult.construction =
          industryTaxResult.type_valtticard === 'construction' ||
          industryTaxResult.type_valtticard === 'construction/shipbuilding'
            ? true
            : false
        userResult.shipbuilding =
          industryTaxResult.type_valtticard === 'shipbuilding' ||
          industryTaxResult.type_valtticard === 'construction/shipbuilding'
            ? true
            : false
        userResult.filePath = industryTaxResult.path
        userResult.document_id = industryTaxResult.document_id
        userResult.fileName = industryTaxResult.filename
        userResult.fileType = industryTaxResult.filetype
        userResult.industryTaxInfo = 'data'
      } else {
        userResult.industryTaxInfo = ''
      }

      const updateUserRows = []
      for (let row of state.userSearchRows) {
        if (row.email == userResult.email) {
          updateUserRows.push({
            ...row,
            expanded: true,
            expandData: userResult,
            taxCard: action.taxCard
          })
        } else updateUserRows.push({ ...row })
      }
      return Object.assign(
        {},
        { ...state },
        {
          userSearchRows: updateUserRows,
          industryTaxCard: action.industryTaxInfo
        }
      )

    case EXPAND_ADMIN_USER_FALSE:
      const closeUserUpdateRows = []
      for (let row of state.userSearchRows) {
        row.uuid == action.uuid
          ? closeUserUpdateRows.push({
              ...row,
              expanded: false,
              expandData: null
            })
          : closeUserUpdateRows.push({ ...row })
      }
      return Object.assign(
        {},
        { ...state },
        { userSearchRows: closeUserUpdateRows }
      )

    /* case UPDATE_ADMIN_INVOICE:
      return Object.assign({}, { ...state }, { showSpinner: true })

    case UPDATE_ADMIN_INVOICE_RESULT:
      return Object.assign(
        {},
        { ...state },
        { showSpinner: false, showAdminSnackbar: true }
      ) */

    /* case UPDATE_ADMIN_USER:
      return Object.assign({}, { ...state }, { showSpinner: true }) */

    case UPDATE_ADMIN_USER_RESULT:
      return Object.assign({}, { ...state }, { showAdminSnackbar: true })

    case SSN_DUPLICATE:
      return Object.assign({}, { ...state }, { showSsnSnackbar: true })

    case UPDATE_ADMIN_USER_RESULT_FAILED:
      return Object.assign({}, { ...state }, { showAdminFailSnackbar: true })

    case ADMIN_UPDATE_INDUSTRY_TAX_CARD_SUCCESS:
      return Object.assign({}, { ...state }, { isUpdateTaxCardSuccess: true })

    case ADMIN_UPDATE_INDUSTRY_TAX_CARD_FAILED:
      return Object.assign({}, { ...state }, { isUpdateTaxCardFailed: true })

    case HIDE_ADMIN_SNACKBAR:
      return Object.assign(
        {},
        { ...state },
        {
          showAdminSnackbar: false,
          showAdminFailSnackbar: false,
          showAdminSalPayFailSnackbar: false,
          showAdminSalaryStatusSuccessSnackbar: false,
          showExpenseReportSuccessSnackbar: false,
          showExpenseReportFailedSnackbar: false,
          expenseReportFailedMessage: '',
          showPartialPayFailSnackbar: false,
          partialPayFailMessage: '',
          isUpdateTaxCardSuccess: false,
          isUpdateTaxCardFailed: false,
          showSsnSnackbar: false
        }
      )

    case IR_SEARCH_PAGE_CHANGE:
      return Object.assign(
        {},
        { ...state },
        { selected: action.selected.selected }
      )

    case USER_SEARCH_PAGE_CHANGE:
      return Object.assign(
        {},
        { ...state },
        { selected: action.selected.selected }
      )

    case TIEDOTTEET_SEARCH_PAGE_CHANGE:
      return Object.assign(
        {},
        { ...state },
        { selected: action.selected.selected }
      )

    case WARN_INVOICE_TO_PAY:
      let invResult = action.selected
      let invResultSplit = invResult.split('$$')

      let invoiceCheckedResult =
        invResultSplit[0] + '$$' + invResultSplit[1] + '$$' + invResultSplit[2]
      //console.log('WARN_INVOICE_TO_PAY:: ', invoiceCheckedResult)

      let invoiceStatus = invResultSplit[3]
      //console.log('invResultSplit[3]:: ', invoiceStatus)

      const is_group_invoice = invResultSplit[7] === '1' ? true : false
      //console.log('is_group_invoice', is_group_invoice)

      const isReminderActive = checkReminder(
        invResultSplit[8] === 'true' ? true : false,
        invResultSplit[4],
        invResultSplit[5]
      )

      const invoiceNotes = invResultSplit[6]

      let isInvoiceUnclear = false
      let isPerinnassa = false
      let isReklamoitu = false
      let isLahetetty = false
      let isMuokattu = false
      let isAdminSent = false
      let isAdminRejected = false
      let isAdminHalfPaid = false

      if (invoiceStatus == 7 || invoiceStatus == 8) {
        isInvoiceUnclear = true
      }

      if (invoiceStatus == 9) {
        isPerinnassa = true
      }

      if (invoiceStatus == 10) {
        isReklamoitu = true
      }

      if (invoiceStatus == 1) {
        isLahetetty = true
      }

      if (invoiceStatus == 13) {
        isMuokattu = true
      }

      if (invoiceStatus == 17) {
        isAdminSent = true
      }

      if (invoiceStatus == 19) {
        isAdminHalfPaid = true
      }

      if (invoiceStatus == 20) {
        isAdminRejected = true
      }

      return Object.assign(
        {},
        { ...state },
        {
          //isToPayInvoiceId: action.selected,
          isToPayInvoiceId: invoiceCheckedResult,
          isToPay: true,
          invoicepaid: 0,
          isInvoiceUnclear: isInvoiceUnclear,
          isPerinnassa: isPerinnassa,
          isReklamoitu: isReklamoitu,
          isLahetetty: isLahetetty,
          isMuokattu: isMuokattu,
          isAdminSent: isAdminSent,
          isAdminRejected: isAdminRejected,
          isAdminHalfPaid: isAdminHalfPaid,
          isReminderActive: isReminderActive,
          invoiceNotes: invoiceNotes,
          is_group_invoice: is_group_invoice
        }
      )

    case CLOSE_DIALOG:
      return Object.assign(
        {},
        { ...state },
        {
          isToPay: false
        }
      )

    case CANCEL_UPDATE_ADMIN_INVOICE_STATUS:
      return Object.assign(
        {},
        { ...state },
        {
          isToPayInvoiceId: 0,
          isToPay: false,
          invoicepaid: 0,
          instant_payment: '',
          isInvoiceUnclear: false,
          isPerinnassa: false,
          isLahetetty: false,
          isReklamoitu: false,
          isMuokattu: false,
          isAdminSent: false,
          isAdminRejected: false,
          isAdminHalfPaid: false,
          is_group_invoice: false
        }
      )

    case UPDATE_ADMIN_INVOICE_STATUS:
      return Object.assign(
        {},
        { ...state },
        {
          isToPay: false,
          isInvoiceUnclear: false,
          instant_payment: 'quick_pay',
          isPerinnassa: false,
          isReklamoitu: false,
          isLahetetty: false,
          isMuokattu: false,
          isAdminSent: false,
          isAdminRejected: false,
          isAdminHalfPaid: false
        }
      )

    case NO_PIKAPALKKA:
      return Object.assign(
        {},
        { ...state },
        {
          isToPay: false,
          instant_payment: '',
          isLahetetty: false
        }
      )

    //For Single Payment Selection
    /*     case WARN_SALARY_TO_PAY:
        let salResult = action.selected

        let salResultSplit =  salResult.split('$$')
        let salResultStatus =  salResultSplit[2]

        let isImportSalary
        if(salResultStatus === 'bankaccept'){
          isImportSalary = true
        }else if((salResultStatus === 'processing') || (salResultStatus === 'bankreject')){
          isImportSalary = false
        }
      return Object.assign(
        {},
        { ...state },
        {
          isToPaySalaryId: action.selected,
          isToLiftSalary: true,
          Status: 'bankingprocess',
          isImportSalary: isImportSalary
        }
      ) */

    case CONFIRM_SALARY_TO_PAY:
      return Object.assign(
        {},
        { ...state },
        {
          isToLiftSalary: true
        }
      )

    //For Batch Payment Selection
    case WARN_SALARY_TO_PAY:
      let salResult = action.selected
      let salResultSplit = salResult.split('$$')
      let salaryCheckedResult = salResultSplit[0] + '$$' + salResultSplit[1]
      const updateSalaryRows = []
      for (let row of state.salarySearchRows) {
        if (`${row.uuid}$$${row.id}` == salaryCheckedResult) {
          const toggleCheck = !row.isChecked
          updateSalaryRows.push({
            ...row,
            isChecked: toggleCheck
          })
        } else {
          updateSalaryRows.push({ ...row })
        }
      }
      let selectedSalaryRows = []
      selectedSalaryRows = updateSalaryRows.filter(
        (item) => `${item.uuid}$$${item.id}` == salaryCheckedResult
      )
      let fullSelectedSalaryRows = []
      /*'jaya added'*/
      let isExist = false
      for (var i = 0; i < state.selectedRows.length; i++) {
        //  console.log('ifloop'+state.selectedRows[i].uuid+' '+state.selectedRows[i].id+''+salResultSplit[0]+''+salResultSplit[1])
        if (
          state.selectedRows[i].uuid == salResultSplit[0] &&
          state.selectedRows[i].id == salResultSplit[1]
        ) {
          //  console.log('insideifloop')
          isExist = true
          state.selectedRows[i].isChecked = !state.selectedRows[i].isChecked
        }
      }
      if (isExist == false) {
        fullSelectedSalaryRows = _handleSalaryRowClick(
          selectedSalaryRows,
          state.selectedRows.filter((e) => e.isChecked == true)
        )
      } else
        fullSelectedSalaryRows = state.selectedRows.filter(
          (e) => e.isChecked == true
        )

      let group = fullSelectedSalaryRows.map((a) => a.status)
      let dedtGroup = fullSelectedSalaryRows.map((a) => a.dedtstatus)
      let validGroup = isValidGroup(group)
      let validDedtGroup = isValidGroup(dedtGroup)

      //Added to handle mix of selections
      let isImportSalary
      let isValidBatch
      let isIRValidBatch
      let isIRCacelReportValidBatch
      if (
        (group[0] === 'bankreject' && validGroup === true) ||
        (dedtGroup[0] === 'bankreject' && validDedtGroup === true)
      ) {
        isImportSalary = false
        isValidBatch = true
        isIRValidBatch = false
        isIRCacelReportValidBatch = false
      } else if (
        group[0] === 'bankaccept' &&
        validGroup === true &&
        (dedtGroup[0] === 'bankaccept' || dedtGroup[0] === 'Pplasku') &&
        validDedtGroup === true
      ) {
        // KAS-611 Keep the old fix for further reference
        // isImportSalary = true
        // isValidBatch = true
        // isIRValidBatch = false
        // isIRCacelReportValidBatch = false
        isImportSalary = false
        isValidBatch = false
        isIRValidBatch = true
        isIRCacelReportValidBatch = false
      } else if (
        (group[0] === 'processing' && validGroup === true) &&
        (dedtGroup[0] === 'processing' && validDedtGroup === true)
      ) {
        isImportSalary = false
        isValidBatch = true
        isIRValidBatch = false
        isIRCacelReportValidBatch = false
      } else if (
        (group[0] === 'processing' || group[0] === 'bankingprocess') &&
        validGroup === true
      ) {
        isImportSalary = false
        isValidBatch = true
        isIRValidBatch = false
        isIRCacelReportValidBatch = false
      } else if (group[0] === 'paid' && validGroup === true) {
        isIRValidBatch = true
        isImportSalary = false
        isValidBatch = false
        isIRCacelReportValidBatch = false  
      } else if (dedtGroup[0] === 'Pplasku' && validDedtGroup === true) {
        isImportSalary = false
        isValidBatch = true
        isIRValidBatch = false
        isIRCacelReportValidBatch = false
      } else if (group[0] === 'IRRejected' && validGroup === true) {
        isIRValidBatch = true
        isImportSalary = false
        isValidBatch = false
        isIRCacelReportValidBatch = false
      } else if (group[0] === 'IRCancelled' && validGroup === true) {
        isIRValidBatch = true
        isImportSalary = false
        isValidBatch = false
        isIRCacelReportValidBatch = false
      } else if (group[0] === 'IRManual' && validGroup === true) {
        isIRValidBatch = true
        isImportSalary = false
        isValidBatch = false
        isIRCacelReportValidBatch = false
      } else if (group[0] === 'IRValid' && validGroup === true) {
        isIRValidBatch = false
        isImportSalary = false
        isValidBatch = false
        isIRCacelReportValidBatch = true
      } else if (group[0] === 'IRRejectCancelled' && validGroup === true) {
        isIRValidBatch = false
        isImportSalary = false
        isValidBatch = false
        isIRCacelReportValidBatch = true
      } else {
        isImportSalary = false
        isValidBatch = false
        isIRValidBatch = false
        isIRCacelReportValidBatch = false
      }

      return Object.assign(
        {},
        { ...state },
        { salarySearchRows: updateSalaryRows },
        { isSalaryRowSelected: true },
        !!salResultSplit[4] && {
          selectedSalaryRowIndex: Number(salResultSplit[4])
        },
        { Status: 'bankingprocess' },
        isExist == false
          ? {
              selectedRows: _handleSalaryRowClick(
                selectedSalaryRows,
                state.selectedRows.filter((e) => e.isChecked == true)
              )
            }
          : {
              selectedRows: state.selectedRows
            },
        { isImportSalary: isImportSalary },
        { isValidBatch: isValidBatch },
        { isIRValidBatch: isIRValidBatch },
        { isIRCacelReportValidBatch: isIRCacelReportValidBatch }
      )

    //For Single Payment Selection
    /*     case CANCEL_UPDATE_AMDIN_SALARY_STATUS:
      return Object.assign(
        {},
        { ...state },
        {
          isToPaySalaryId: 0,
          isToLiftSalary: false,
          Status: 'processing'
        }
      ) */

    //For Batch Payment Selection
    case CANCEL_UPDATE_ADMIN_SALARY_STATUS:
      let array1 = state.salarySearchRows
      let array2 = action.id || []

      let clearAllSelectedRows = concatReverseReduceSortFunction(array1, array2)
      //console.log('Inside CANCEL_UPDATE_AMDIN_SALARY_STATUS,clearAllSelectedRows ', clearAllSelectedRows)

      let recentSalaryRows = []

      for (let row of clearAllSelectedRows) {
        recentSalaryRows.push({
          ...row,
          isChecked: false
        })
      }
      //console.log('Inside CANCEL_UPDATE_AMDIN_SALARY_STATUS,recentSalaryRows ', recentSalaryRows)

      return Object.assign(
        {},
        { ...state },
        {
          isToLiftSalary: false,
          salarySearchRows: recentSalaryRows,
          isSalaryRowSelected: false,
          Status: 'processing',
          selectedRows: []
        }
      )
    case REMOVE_PAYMENT_DIALOG:
      return Object.assign(
        {},
        { ...state },
        {
          isToLiftSalary: false
        }
      )

    case CANCEL_UPDATE_ADMIN_SALARY_STATUS_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          isValidBatch: true,
          isIRValidBatch: true,
          isIRCacelReportValidBatch: true
        }
      )

    case UPDATE_ADMIN_SALARY_STATUS:
      return Object.assign(
        {},
        { ...state },
        {
          isToLiftSalary: false
        }
      )

    case SALARY_SEND_TO_IR:
      return Object.assign(
        {},
        { ...state },
        {
          isToLiftSalary: false
        }
      )
    case CANCEL_SALARY_IR_REPORT:
      return Object.assign(
        {},
        { ...state },
        {
          isToLiftSalary: false
        }
      )

    case UPDATE_ADMIN_BANK_PAYMENT_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          isImportSalary: true
        }
      )

    case UPDATE_ADMIN_BANK_PAYMENT_FAILED:
      return Object.assign(
        {},
        { ...state },
        {
          showAdminSalPayFailSnackbar: true,
          salPayFailMessage: action.result,
          isToPaySalaryId: 0,
          selectedRows: []
        }
      )
    case UPDATE_ADMIN_IR_FAILED:
      return Object.assign(
        {},
        { ...state },
        {
          showAdminSalPayFailSnackbar: true,
          salPayFailMessage: action.result,
          isToPaySalaryId: 0,
          selectedRows: []
        }
      )

    case UPDATE_ADMIN_INVOICE_STATUS_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          isToPayInvoiceId: 0,
          instant_payment: ''
        }
      )

    case UPDATE_ADMIN_INVOICE_STATUS_REJECTED:
      return Object.assign(
        {},
        { ...state },
        {
          isToPay: false,
          instant_payment: '',
          isPerinnassa: false,
          isReklamoitu: false,
          isLahetetty: false
        }
      )

    case UPDATE_ADMIN_INVOICE_STATUS_NEW:
      return Object.assign(
        {},
        { ...state },
        {
          isToPay: false,
          instant_payment: '',
          isLahetetty: false,
          isPerinnassa: false,
          isReklamoitu: false
        }
      )

    case UPDATE_ADMIN_INVOICE_STATUS_LOANED:
      return Object.assign(
        {},
        { ...state },
        {
          isToPay: false,
          instant_payment: '',
          isLahetetty: false
        }
      )

    case UPDATE_ADMIN_INVOICE_STATUS_NOT_ACCEPTED:
      return Object.assign(
        {},
        { ...state },
        {
          isToPay: false,
          isInvoiceUnclear: false,
          instant_payment: ''
        }
      )

    case UPDATE_ADMIN_INVOICE_STATUS_PAID_AND_NEW_INVOICE:
      return Object.assign(
        {},
        { ...state },
        {
          isToPay: false,
          isInvoiceUnclear: false,
          instant_payment: ''
        }
      )

    case UPDATE_ADMIN_SALARY_STATUS_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          isToPaySalaryId: 0,
          isSalaryRowSelected: false,
          isToLiftSalary: false,
          selectedRows: [],
          showAdminSalaryStatusSuccessSnackbar: true,
          salaryStatusSuccessMessage: action.result
        }
      )

    case UPDATE_ADMIN_SALARY_STATUS_FAILED:
      return Object.assign(
        {},
        { ...state },
        {
          showAdminSalPayFailSnackbar: true,
          salPayFailMessage: 'Salary payment failed'
        }
      )

    case ADMIN_GET_UPDATES_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        { releaseSearchRows: action.result }
      )

    case UPDATE_ADMIN_TABLE:
      return Object.assign(
        {},
        { ...state },
        {
          shouldUpdateTable: true
        }
      )

    case UPDATE_ADMIN_TABLE_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          shouldUpdateTable: false
        }
      )

    case ADMIN_GENERATE_PDF_FAILED:
      return Object.assign(
        {},
        { ...state },
        {
          showPartialPayFailSnackbar: true,
          partialPayFailMessage: action.result.data
        }
      )

    case EXPAND_ADMIN_SALARY_TRUE:
      let salaryResult = action.result
      const updateSalarySearchRows = []
      for (let row of state.salarySearchRows) {
        if (row.id == salaryResult.id) {
          updateSalarySearchRows.push({
            ...row,
            expanded: true,
            expandData: salaryResult
          })
        } else updateSalarySearchRows.push({ ...row })
      }
      return Object.assign(
        {},
        { ...state },
        {
          salarySearchRows: updateSalarySearchRows,
          adminSalaryEdit: action.result
        }
      )

    case EXPAND_ADMIN_SALARY_FALSE:
      const closeUpdateSalarySearchRows = []
      for (let row of state.salarySearchRows) {
        row.id == action.id
          ? closeUpdateSalarySearchRows.push({
              ...row,
              expanded: false,
              expandData: null
            })
          : closeUpdateSalarySearchRows.push({ ...row })
      }
      return Object.assign(
        {},
        { ...state },
        { salarySearchRows: closeUpdateSalarySearchRows }
      )

    case GET_ADMIN_SALARY_ULOSOTTO_INFO_SUCCESS:
      const { 
        currentmonth_sumulosotto, 
        max_monthly_govpay 
      } = action.result

      return Object.assign(
        {},
        { ...state },
        {
          currentMonthSumUlosotto: currentmonth_sumulosotto,
          maxMonthlyGovPay: max_monthly_govpay
        }
      )

    case CLOSE_ADMIN_SALARY_FORMS:
      return Object.assign(
        {},
        { ...state },
        {
          shouldCloseSalaryForms: true
        }
      )

    case CLOSE_ADMIN_SALARY_FORMS_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          shouldCloseSalaryForms: false
        }
      )

    case REMOVE_INVOICE_FEE_WITH_REASON:
      return Object.assign(
        {},
        { ...state },
        {
          showRemoveInvoiceFeeDialog: true,
          feeType: action.feeType
        }
      )

    case CANCEL_REMOVE_INVOICE_FEE_DIALOG:
      return Object.assign(
        {},
        { ...state },
        {
          showRemoveInvoiceFeeDialog: false
        }
      )

    default:
      return state
  }
}

const _handleSalaryRowClick = (selectedRows, previous) => {
  let salaryRowSelected = previous
  let newSelected = []

  newSelected = newSelected.concat(salaryRowSelected, selectedRows)
  //console.log('Inside _handleSalaryRowClick newSelected:: ',newSelected)

  salaryRowSelected = newSelected
  //console.log('Inside _handleSalaryRowClick salaryRowSelected:: ',salaryRowSelected)

  return salaryRowSelected
}

const checkReminder = (is_payment_control, due_date, remindersent) => {
  if (
    is_payment_control &&
    new Date(due_date) < new Date() &&
    remindersent == 1
  ) {
    return true
  } else {
    return false
  }
}

export default adminReducer
